<template>
  <el-card class="page-container">
    <div ref="formHeightRef">
      <el-form :inline="true" :model="form" ref="form" @submit.native.prevent="search">
        <el-form-item label="" prop="keyWord">
          <el-input v-model="form.keyWord" placeholder="设备名称/编码" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="manufacturerCode">
          <el-select v-model="form.manufacturerCode" clearable placeholder="请选择设备厂商">
            <el-option
              v-for="item in facturerList"
              :key="item.code"
              :label="item.displayName"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="status">
          <el-select v-model="form.status" clearable placeholder="请选择运行状态">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="在线" :value="1"></el-option>
            <el-option label="离线" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="isPosition">
          <el-select v-model="form.isPosition" clearable placeholder="请选择点位设置">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="已设置点位" :value="true"></el-option>
            <el-option label="未设置点位" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
          <el-button type="primary" :disabled="!$hasAccess('update')" @click="batchSetBroadcast">设置广播</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="tableData"
      border
      stripe
      :height="`calc(100vh - 200px - ${formHeight}px)`"
      @selection-change="handleSelect"
      v-loading="tableLoading"
    >
      <el-table-column type="selection" width="60"></el-table-column>
      <el-table-column label="序号" prop="seqNo" width="60" :align="alignType"></el-table-column>
      <el-table-column label="设备编码" prop="code" :align="alignType"></el-table-column>
      <el-table-column label="设备名称" prop="name" :align="alignType"></el-table-column>
      <el-table-column label="设备厂商" prop="manufacturerCode" show-overflow-tooltip :align="alignType">
        <template slot-scope="{row}">
          {{factureMap[row.manufacturerCode] || row.manufacturerCode}}
        </template>
      </el-table-column>
      <el-table-column label="设备类型名称" prop="deviceType" show-overflow-tooltip :align="alignType">
        <template slot-scope="{row}">
          {{deviceTypeMap[row.deviceType] || row.deviceType}}
        </template>
      </el-table-column>
      <el-table-column label="运行状态" prop="status" :align="alignType">
        <template slot-scope="{row}">
          <div v-if="row.status === 1" class="successTextColor">在线</div>
          <div v-if="row.status === 2" class="infoText">离线</div>
          <div v-if="row.status === 0" class="infoText">未知</div>
        </template>
      </el-table-column>
      <el-table-column label="点位设置" prop="setPosition" :align="alignType">
        <template slot-scope="{row}">
          {{row.isSetPosition ? '√' : '-'}}
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" :align="alignType">
        <template slot-scope="{row}">
          <el-button size="small" @click="setBroadcast(row)">设置广播</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      class="mt-20px"
      background
      @size-change="getList"
      @current-change="getList"
      :current-page.sync="initPagination.pageNum"
      :page-size.sync="initPagination.pageSize"
      :total="initPagination.total"
      layout="->,total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
    <el-dialog
      :title="'广播设置'"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :append-to-body="false"
      class="small-dialog"
      v-dialogDrag
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        inline
        label-width="150px"
        size="small"
      >
        <el-form-item label="广播内容" prop="broadcastContent">
          <el-input
            type="textarea"
            rows="16"
            maxlength="2000"
            v-model="ruleForm.broadcastContent"
            placeholder="请输入"
            clearable
          ></el-input>
          <div>同时支持多个广播设备同时播报</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="confirm" :loading="saveLoading">保存</el-button>
        <el-button @click="dialogShow = false" size="small">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import tableHeightMixin from '@/mixins/tableHeightMixin'
import { IOTDeviceApi, IOTBroadcastApi } from '@wiz-api/iot-device-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'

const dataCategoryApi = new DataCategoryApi()
const iotDeviceApi = new IOTDeviceApi()
const iotBroadcastApi = new IOTBroadcastApi()

export default {
  name: 'broadcast-apply',
  mixins: [tableHeightMixin],
  data() {
    return {
      selectedRows: [],
      saveLoading: false,
      dialogShow: false,
      ruleForm: {
        broadcastContent: '',
      },
      rules: {
        broadcastContent: [{ required: true, message: '请输入广播内容', trigger: 'change' }],
      },
      facturerList: [],
      deviceTypeList: [],
      factureMap: {},
      deviceTypeMap: {},
      alignType: 'left',
      form: {
        keyWord: '',
        manufacturerCode: '',
        status: '',
        isPosition: '',
        isMonitorRange: '',
      },
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
    }
  },
  methods: {
    formatDate(row, column, cellValue) {
      if (cellValue) return dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss')
      return cellValue
    },
    search() {
      this.initPagination.pageNum = 1
      this.getList()
    },
    reset() {
      this.$refs.form.resetFields()
    },
    async getList() {
      this.tableLoading = true
      const res = await iotDeviceApi.getDeviceWithDetailPageList({
        deviceTypeCode: 'Broadcast',
        ...this.form,
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      this.tableLoading = false
      if (res[1]) {
        res[1].items.forEach((item, index) => {
          item.seqNo =
            (this.initPagination.pageNum - 1) * this.initPagination.pageSize + (index + 1)
          item.isSetPosition = item.threeDPosition && JSON.parse(item.threeDPosition).length > 0
          item.isSetMonitorRange = item.threeDMonitorRange && JSON.parse(item.threeDMonitorRange).length > 0
        })
        this.tableData = res[1].items || []
        this.initPagination.total = res[1].totalCount
        this.selectedRows = []
      }
    },
    // 批量设置广播
    batchSetBroadcast() {
      if (this.selectedRows.length > 0) {
        this.dialogShow = true
      } else {
        this.$message.warning('请勾选要设置的设备')
      }
    },
    // 设置广播
    async setBroadcast(row) {
      this.currentRow = row
    },
    // 获取数据字典数据
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['IOTDeviceTemplateManufacturer', 'IOTDeviceTemplateDeviceType'],
        includeDetails: true,
      })
      if (!err) {
        let facturerList = []
        let deviceTypeList = []
        res.forEach((item) => {
          if (item.code === 'IOTDeviceTemplateManufacturer') { // 设备厂商
            facturerList = item.dataItems
          }
          if (item.code === 'IOTDeviceTemplateDeviceType') { // 类型归属
            deviceTypeList = item.dataItems
          }
        })
        this.facturerList = facturerList
        this.deviceTypeList = deviceTypeList
        this.factureMap = facturerList.reduce((map, cur) => {
          map[cur.code] = cur.displayName
          return map
        }, {})
        this.deviceTypeMap = deviceTypeList.reduce((map, cur) => {
          map[cur.code] = cur.displayName
          return map
        }, {})
        this.getList()
      }
    },
    handleSelect(res) {
      this.selectedRows = res
    },
    confirm() {
      this.$refs.ruleForm.validate(async (validRuleForm) => {
        if (validRuleForm) {
          this.saveLoading = true
          const params = {
            dids: this.selectedRows.map((item) => {
              return item.id
            }),
            content: this.ruleForm.broadcastContent
          }
          try {
            const [err] = await iotBroadcastApi.realForString({
              body: params
            })
            this.saveLoading = false
            if (!err) {
              this.getList()
            }
          } catch (error) {
            this.saveLoading = false
          }
        }
      })
    }
  },
  async created() {
    this.getCategoryByCodes()
  },
}
</script>

<style lang="scss" scoped>
.successTextColor {
  color: var(--tagSuccessText);
}
.infoText {
  color: var(--tagInfoText);
}
</style>
